<template>
  <v-card
    v-if="datasets[options.dataset.id]"
    class="legend"
    flat
    tile
  >
    <v-subheader
      style="height:36px; line-height:1"
      class="px-0"
    >
      {{ fields[options.field].title || fields[options.field]['x-originalName'] || fields[options.field].key }}
    </v-subheader>
    <ul>
      <li
        v-for="(item, i) in colors"
        :key="i"
        style="cursor:pointer;"
      >
        <v-icon
          :color="item.color"
        >
          mdi-square
        </v-icon>
        &nbsp;{{ config.colors.enumOptions ? formatField({[options.field]:item.value}, fields[options.field]) : item.value }}
      </li>
    </ul>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatField } from '@data-fair/components-app/format/fields'

export default {
  computed: {
    ...mapState(['datasets', 'colors']),
    ...mapGetters(['config']),
    options () {
      return this.config.colors.rangeOptions || this.config.colors.enumOptions
    },
    fields () {
      return this.datasets[this.options.dataset.id].schema.reduce((a, b) => { a[b.key] = b; return a }, {})
    }
  },
  methods: {
    formatField
  }
}
</script>

<style>
.v-card.legend ul {
  list-style-type: none;
  padding-left: 0px;
  margin-top: 0;
  margin-bottom: 0px;
}
</style>
